module.exports = __webpack_public_path__ + "static/media/casemanager.5e50560b.svg";